import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { IoClose } from "react-icons/io5";
import { Select } from "antd";
import "antd/dist/reset.css";
import { toast } from "react-hot-toast";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import SelectPrivacy from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
// import SuccessToast from "../SuccessToast";
// import ErrorToast from "../ErrorToast";
// import WarningToast from "../WarningToast";

const AddArticle = ({ showModal, closeModal }) => {
  const [title, setTitle] = useState("");
  const [tags, setTags] = useState([]);
  const [bannerImage, setBannerImage] = useState(null);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open");
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open");
    }
  }, [showModal]);

  const tagOptions = ["React", "Mongo", "Express", "Node"];

  // Selected tags state
  const [selectedTags, setSelectedTags] = useState([]);

  // Handle tag change
  const handleTagChange = (values) => {
    setSelectedTags(values);
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setBannerImage(e.target.files[0]);
    }
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };

  //Add article
  const sessionId = localStorage.getItem("sessionId");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [display, setDisplay] = useState(false);
  const [isloading, setIsloading] = useState(false);

  const [images, setImages] = useState([]);
  const editorRef = useRef(null);
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [query, setQuery] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const userUid = localStorage.getItem("userUid");
  const [description, setDescription] = useState("");
  const [SearchText, setSearchText] = useState("")

  const handleArticleChange = (content, delta, source, editor) => {
    const value = editor.getText(); // plain text, better than content HTML
    const caret = editor.getSelection()?.index || 0;

    setDescription(content); // still keep full HTML
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // Filter out dynamic values no longer in content
    const updatedDynamicValues = postDynamicValues.filter(
      ({ type, display }) => {
        const prefix = type === "UserMention" ? "@" : "#";
        const fullMention = `${prefix}${display}`;
        return value.includes(fullMention);
      }
    );

    // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1,
    }));

    setPostDynamicValues(reassignedDynamicValues);

    // Recompute postInputValue
    const quillInstance = editorRef.current?.getEditor?.();
    const htmlContent = quillInstance?.root?.innerHTML || "";

    const updatedPostInputValue = updatePostInputValueWithDynamicValues(
      htmlContent,
      reassignedDynamicValues
    );

    setPostInputValue(updatedPostInputValue);
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, display }) => {
      const prefix = type === "UserMention" ? "@" : "#";
      const fullMention = `${prefix}${display}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      // setShowSuggestions(false);
      setSearchText('')
    }
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(
          `General/MentionTagDDL?Search=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(
          `General/HashtagDDL?SearchHashtag=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  const insertMention = (suggestion, userUid) => {
    const quill = editorRef.current?.getEditor?.();
    if (!quill) return;

    const cursorPosition = quill.getSelection()?.index || 0;
    const textBeforeCursor = quill.getText(0, cursorPosition);
    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const mentionPrefix = mentionType === "UserMention" ? "@" : "#";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    // Replace partial mention with full one
    quill.deleteText(startIndex, match[0].length);
    quill.insertText(startIndex, mentionText);
    quill.setSelection(startIndex + mentionText.length);

    // Update dynamic values
    const safePostDynamicValues = Array.isArray(postDynamicValues)
      ? postDynamicValues
      : [];
    const dVno = safePostDynamicValues.length + 1;

    const updatedPostDynamicValues = [
      ...safePostDynamicValues,
      {
        type: mentionType,
        dVno,
        entity: mentionType === "UserMention" ? userUid : suggestion,
        display: displayName,
      },
    ];
    setPostDynamicValues(updatedPostDynamicValues);

    const editorHtml = quill.root.innerHTML;
    const updatedInputValue = updatePostInputValueWithDynamicValues(
      editorHtml,
      updatedPostDynamicValues
    );
    setPostInputValue(updatedInputValue);
    setShowSuggestions(false);
    setSearchText('')
  };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const [privacyType, setPrivacyType] = useState("Public");
  const Privacy = [
    { value: "Public", label: "Public" },
    { value: "Friends", label: "Friends" },
    { value: "OnlyMe", label: "OnlyMe" },
    { value: "Custom", label: "Custom" },
  ];
  const handleSubmit = async () => {
    setIsloading(true);
    try {
      setDisplay(true);
      const formData = new FormData();
      formData.append("DeviceType", "Web");
      formData.append("sessionId", sessionId);
      formData.append("PrivacyType", privacyType || "Public");
      formData.append("PostOriginType", "User");
      formData.append("BannerFile", bannerImage);
      formData.append("PostOriginID", userUid);
      formData.append("PostCategory", "Article");
      formData.append("Title", title);
      formData.append(
        "PostContent",
        postInputValue ? postInputValue : description
      );
      formData.append("Tags", selectedTags);
      formData.append("DynamicValues", JSON.stringify(postDynamicValues));
      const res = await axios.post("/Posts/CreateArticle", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setToastMessage(res.data.message || "Article created successfully");
      setShowToast(true);
      setTitle("");
      setBannerImage(null);
      setDescription("");
      setSelectedTags([]);
      setPostInputValue("");
      setPostDynamicValues([]);
      closeModal();
      // const newPostId = res?.data?.responseData?.id;
      // const postDetailsResponse = await axios.post(
      //   `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}`
      // );
      // const newPost = postDetailsResponse?.data?.responseData;
      // setPostList((prev) => [newPost, ...prev]);
      // setPostContent("");
      // setImages([]);
      // setPostID("");
      // setShowSecondModal(false);
      setIsloading(false);
      setPostDynamicValues([]);
      setPostInputValue("");
    } catch (error) {
      console.log("newPostId", error);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
      setIsloading(false);
    }
  };
  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="container articleContainer mt-4 mb-5  d-flex justify-content-center">
            <div className="col-12">
              <form className="bg-white pb-4">
                <div className="row mb-md-4 mb-2 mt-md-4 mt-2">
                  <div className=" modalBorder d-flex justify-content-between align-items-center p-2">
                    <h6>Post Something</h6>

                    <SelectPrivacy
                      defaultValue={Privacy.find(
                        (option) => option.value === privacyType
                      )}
                      onChange={(selectedOption) => {
                        setPrivacyType(selectedOption.value);
                      }}
                      options={Privacy}
                      placeholder={"Select Privacy"}
                      styles={customStyles}
                      formatOptionLabel={({ label, icon }) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {icon}
                          <span style={{ marginLeft: 8 }}>{label}</span>
                        </div>
                      )}
                    />
                    <CloseSharpIcon className="pointer" onClick={closeModal} />
                  </div>
                </div>
                <hr className="mt-2 mb-4" />
                <div className="row g-4">
                  <div className="col-12 mb-4">
                    <label className="form-label fw-medium">
                      Banner Image *
                    </label>
                    <div className="card rounded-0">
                      <div className="card-body">
                        <div className="custom-file-upload text-center p-2">
                          {bannerImage ? (
                            <div className="preview-container">
                              <img
                                src={URL.createObjectURL(bannerImage)}
                                alt="Preview"
                                className="img-fluid mb-3"
                                style={{ maxHeight: "300px" }}
                              />
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => setBannerImage(null)}
                              >
                                Remove
                              </button>
                            </div>
                          ) : (
                            <>
                              <div className="upload-icon mb-3">
                                <svg
                                  fill="currentColor"
                                  viewBox="0 0 36 36"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="36px"
                                  height="36px"
                                >
                                  <title>image-line</title>
                                  <path d="M32,4H4A2,2,0,0,0,2,6V30a2,2,0,0,0,2,2H32a2,2,0,0,0,2-2V6A2,2,0,0,0,32,4ZM4,30V6H32V30Z" />
                                  <path d="M8.92,14a3,3,0,1,0-3-3A3,3,0,0,0,8.92,14Zm0-4.6A1.6,1.6,0,1,1,7.33,11,1.6,1.6,0,0,1,8.92,9.41Z" />
                                  <path d="M22.78,15.37l-5.4,5.4-4-4a1,1,0,0,0-1.41,0L5.92,22.9v2.83l6.79-6.79L16,22.18l-3.75,3.75H15l8.45-8.45L30,24V21.18l-5.81-5.81A1,1,0,0,0,22.78,15.37Z" />
                                </svg>
                              </div>
                              <p className="mb-3">
                                We recommend uploading or dragging in an image
                                that is 1920x1080 pixels
                              </p>

                              <button
                                className="mainBtn"
                                type="button"
                                onClick={() =>
                                  document.getElementById("fileUpload").click()
                                }
                              >
                                Upload from computer
                              </button>
                              <input
                                id="fileUpload"
                                type="file"
                                className="d-none"
                                accept="image/*"
                                onChange={handleFileChange}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label fw-medium">Title *</label>
                    <div className="input-wrapper">
                      <input
                        type="text"
                        className="form-control rounded-0"
                        placeholder="Enter article title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label fw-medium">Tags</label>
                    <Select
                      mode="tags"
                      style={{ width: "100%" }}
                      placeholder="Enter Tags"
                      onChange={handleTagChange}
                      value={selectedTags}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      dropdownStyle={{
                        zIndex: 9999,
                        position: "fixed",
                      }}
                    >
                      {tagOptions.map((tag) => (
                        <Select.Option key={tag} value={tag}>
                          {tag}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>

                  <div className="col-12 mb-4">
                    <label className="form-label fw-medium">Content *</label>
                    <ReactQuill
                      ref={editorRef}
                      value={description}
                      onChange={(content, delta, source, editor) => {
                        handleArticleChange(content, delta, source, editor);
                      }}
                      modules={modules}
                      className="form-quill"
                    />
                    {showSuggestions && (
                      <ul className="suggestion-box">
                        {mentionType === "Hashtag" ? <li
                          onMouseDown={(e) => {
                            e.preventDefault(); // Prevent editor blur
                            insertMention(
                              SearchText,
                              null
                            );
                          }}
                          className="suggestion-item"
                        >
                          <span>{SearchText ? `#${SearchText}` : ''}</span>
                        </li> : null}
                        {suggestions?.map((item, index) => (
                          <li
                            key={index}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              insertMention(
                                mentionType === "UserMention"
                                  ? item?.entityName
                                  : item?.hashTag,
                                mentionType === "UserMention"
                                  ? item?.userUid
                                  : null
                              );
                            }}
                            className="suggestion-item"
                          >
                            {mentionType === "UserMention" ? (
                              <>
                                <img
                                  src={item?.avatar}
                                  alt={item?.entityName}
                                  className="avatar"
                                />
                                <span>{item?.entityName}</span>
                              </>
                            ) : (
                              <span>#{item?.hashTag}</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                  <div className="col-12 d-flex justify-content-center mt-4">
                    <button
                      className="mainBtn"
                      disabled={isloading}
                      onClick={handleSubmit}
                    >
                      {isloading === true ? "Posting.." : "Post Article"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default AddArticle;
